import { useLanguage } from "@/context/LanguageContext";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import SectionOrnament from "@/components/SectionOrnament";
import PackagesGrid from "@/components/PackagesGrid";

export default function PackagesPage() {
  const { t } = useLanguage();
  useSeo("Packages & Preise", "Forfaits & tarifs", "Bronze, Silber und Gold – unsere Hochzeits- und Event-Packages im Überblick.", "Bronze, Argent et Or – nos forfaits de mariage et d'événement.");
  return (
    <div data-testid="packages-page">
      <PageHero overline={t("packages.overline")} title={t("packages.title")} subtitle={t("packages.sub")} />
      <section className="relative bg-cream py-24 px-6 lg:px-10 overflow-hidden">
        <SectionOrnament variant="corners" />
        <div className="relative max-w-[1400px] mx-auto pt-6">
          <PackagesGrid />
        </div>
      </section>
    </div>
  );
}
